export default __webpack_public_path__ + "static/media/info.f601508f.svg";